import Vue from 'vue'
import VueMask from 'di-vue-mask'

/** Activate vue.js plugins **/
Vue.use(VueMask);